import React from 'react';

import DotsMoreComponent from 'components/Comment/CommentMore';
import ModularCommentDisplay from 'components/Comment/ModularCommentDisplay';
import { useSelector } from 'react-redux';
import { selectLoggedInEmployeeId } from 'selectors/loggedInEmployee';
import styled from 'styled-components';
import { VerticallyAlignedFlexContainer } from 'styles/common';

import { PraiseSvgIconColored } from 'constants/icons';

export default function SidepanelCommentDisplay({
  commentMoreMenuItems,
  isDisabled = false,
  isKudos = false,
  ...props
}) {
  const fromEmployeeId = props.fromEmployee?.id || null;
  const loggedInEmployeeId = useSelector(selectLoggedInEmployeeId);
  const isLoggedInEmployee = fromEmployeeId === loggedInEmployeeId;
  return (
    <StyledModularCommentDisplay isLoggedInEmployee={isLoggedInEmployee} {...props}>
      {!isLoggedInEmployee && <StyledEmployeeImage size="smallest" rightGutter={1} topGutter={0.25} />}
      <MessageContainer isLoggedInEmployee={isLoggedInEmployee} $isKudos={isKudos}>
        <Header>
          <VerticallyAlignedFlexContainer>
            <ModularCommentDisplay.From weight={600} variant="body1" />
            {isKudos ? <PraiseSvgIconColored containerSize="fixed16px" size="fixed16px" leftGutter={1} /> : null}
          </VerticallyAlignedFlexContainer>
          <ModularCommentDisplay.CreatedAt variant="body2" />
        </Header>
        <ModularCommentDisplay.Message display="inline" variant="body2" />
      </MessageContainer>
      <DotsContainer>
        <StyledDotsMoreComponent isDisabled={isDisabled} menuItems={commentMoreMenuItems} />
      </DotsContainer>
      {isLoggedInEmployee && <StyledEmployeeImage size="smallest" leftGutter={1} topGutter={0.25} />}
    </StyledModularCommentDisplay>
  );
}

const StyledModularCommentDisplay = styled(ModularCommentDisplay)`
  display: flex;
  justify-content: ${(props) => (props.isLoggedInEmployee ? 'flex-end' : 'flex-start')};
`;

const MessageContainer = styled.div`
  flex-basis: 75%;
  ${(props) => props.theme.breakpoints.down('xs')} {
    flex-grow: 1;
  }
  background-image: ${(props) =>
    props.isLoggedInEmployee
      ? 'linear-gradient(to left, rgba(233, 246, 255, 0.7), rgba(233, 246, 255, 0.5))'
      : 'linear-gradient(to right, rgba(239, 239, 239, 1), rgba(239, 239, 239, 0.5))'};
  padding: 0.5rem 0.75rem;
  border-radius: 4px;
  ${(props) =>
    props.$isKudos &&
    `
    border: 1px solid ${props.theme.palette.borders.green};
  `}
`;

const StyledEmployeeImage = styled(ModularCommentDisplay.EmployeeImage)`
  border: 1px solid ${(props) => props.theme.palette.borders.grey};
  display: inline-flex;
`;

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StyledDotsMoreComponent = styled(DotsMoreComponent)`
  align-items: flex-start;
`;

const DotsContainer = styled.div`
  display: flex;
  align-items: flex-start;
`;
